/* CRO-B — premium PDP interactions: scroll reveal, cart-icon, sticky mobile ATC */
(function () {
  "use strict";
  if (!document.body || document.body.className.indexOf("template-product") === -1) return;
  document.documentElement.classList.add("crob-js");

  /* ---------- 1. Scroll reveal (robust — never leaves content hidden) ---------- */
  function reveal(e) { e.classList.add("is-in"); }
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll(".crob-reveal:not(.is-in)"));
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: "0px 0px -5% 0px" });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (e) {
      if (e.getBoundingClientRect().top < vh * 0.96) { reveal(e); }  // visible on load → show now
      else { io.observe(e); }
    });
    // safety net: never leave anything permanently hidden
    setTimeout(function () {
      document.querySelectorAll(".crob-reveal:not(.is-in)").forEach(reveal);
    }, 2600);
  }

  /* ---------- 2. Premium cart icon on the ATC ---------- */
  function injectCartIcon() {
    var btn = document.querySelector('.atc-buuton .btn, button[name="add"], .product-form__cart-submit, .add-to-cart');
    if (!btn || btn.querySelector(".crob-cart-ic")) return;
    var label = btn.querySelector("span") || btn;
    var svg = '<svg class="crob-cart-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="18" cy="20" r="1.3"/></svg>';
    label.insertAdjacentHTML("afterbegin", svg);
  }

  /* ---------- 3. Sticky mobile add-to-cart bar ---------- */
  function initStickyBar() {
    if (window.innerWidth > 768) return;
    var atc = document.querySelector('.atc-buuton .btn, button[name="add"], .product-form__cart-submit, .add-to-cart');
    var titleEl = document.querySelector(".product-single__title");
    var priceEl = document.querySelector(".product__price:not(.product__price--compare)");
    if (!atc || !titleEl) return;
    if (document.querySelector(".crob-stickybar")) return;

    var name = titleEl.textContent.trim();
    var price = priceEl ? priceEl.textContent.trim() : "";
    var bar = document.createElement("div");
    bar.className = "crob-stickybar";
    bar.innerHTML =
      '<div class="crob-stickybar__info">' +
        '<div class="crob-stickybar__name">' + name + "</div>" +
        (price ? '<div class="crob-stickybar__price">' + price + "</div>" : "") +
      "</div>" +
      '<button type="button" class="crob-stickybar__btn">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="18" cy="20" r="1.3"/></svg>' +
        "Kosárba" +
      "</button>";
    document.body.appendChild(bar);

    // keep the sticky price in sync with the live (variant) price
    var liveBtn = bar.querySelector(".crob-stickybar__btn");
    liveBtn.addEventListener("click", function () { atc.click(); });
    function syncPrice() {
      var p = document.querySelector(".product__price:not(.product__price--compare)");
      var pn = bar.querySelector(".crob-stickybar__price");
      if (p && pn) pn.textContent = p.textContent.trim();
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // show the bar once the real ATC has scrolled out of view
        if (en.isIntersecting) { bar.classList.remove("is-in"); }
        else if (en.boundingClientRect.top < 0) { bar.classList.add("is-in"); syncPrice(); }
      });
    }, { threshold: 0 });
    io.observe(atc);
  }

  /* ---------- Premium title-casing (only fixes shouty ALL-CAPS titles) ---------- */
  function premiumTitle() {
    var el = document.querySelector(".product-single__title");
    if (!el || el.dataset.crobCased) return;
    var t = el.textContent.trim();
    if (t.length > 3 && t === t.toLocaleUpperCase("hu") && t !== t.toLocaleLowerCase("hu")) {
      var parts = t.split("|").map(function (seg) {
        seg = seg.trim().toLocaleLowerCase("hu");
        return seg.charAt(0).toLocaleUpperCase("hu") + seg.slice(1);
      });
      el.textContent = parts.join("  |  ");
    }
    el.dataset.crobCased = "1";
  }

  /* ---------- Strip stray emoji from the footer (premium) ---------- */
  function cleanFooter() {
    var footer = document.querySelector(".site-footer, footer");
    if (!footer) return;
    footer.querySelectorAll(".site-footer__title, .h4, h3, h4").forEach(function (el) {
      if (/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{1F1E6}-\u{1F1FF}]/u.test(el.textContent)) {
        el.textContent = el.textContent.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{1F1E6}-\u{1F1FF}]/gu, "").trim();
      }
    });
  }

  function init() { premiumTitle(); initReveal(); injectCartIcon(); initStickyBar(); cleanFooter(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
  // re-run reveal after late content (apps/recommendations) loads
  window.addEventListener("load", function () { setTimeout(initReveal, 400); });
  // Shopify theme editor
  document.addEventListener("shopify:section:load", function () { setTimeout(init, 60); });
})();
